<h2 mat-dialog-title>{{ data.title || 'FTP User Settings' }}</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <span
    >Server: <b>{{ data.server }}</b></span
  >
  <form [formGroup]="form">
    <app-input-field
      label="Password"
      placeholder="Password"
      formControlName="password"
      type="password"
      autocomplete="new-password"
    ></app-input-field>
  </form>
  <div class="column">
    <span>Directory Access:</span>
    <b>{{ data.homeDir }}</b>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">
    {{ data.primaryButtonText || 'Save Changes' }}
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
